module.exports = __webpack_public_path__ + "static/media/white_yamahaMotor.f81c4abf.png";